import { createVNode as n, mergeProps as d } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/CalendarOutlinedStandard.js";
import l from "../components/PfIcon.js";
const r = (t, a) => {
  const e = {
    ...t,
    ...a.attrs
  };
  return n(l, d(e, {
    icon: o
  }), null);
};
r.displayName = "CalendarOutlinedStandard";
r.inheritAttrs = !1;
export {
  r as default
};
